<template>
  <div class="content">
    <div class="contentAll">
      <div class="loginAll" :class="isWeChatEnv?'loginAllWx':''">
        <div class="login-container">
          <div class="custom-field">
            <div style="display: flex; flex: 1">
              <input
                v-model="phone"
                placeholder="请输入手机号"
                class="input-field"
              />
            </div>
            <!-- 修改：static → assets -->
            <img
              v-if="phone"
              src="~@/assets/clear.png"
              style="width: 14px; height: 14px; cursor: pointer"
              @click="phone = ''"
              alt="清除"
            />
          </div>
        </div>

        <div class="login-container">
          <div class="custom-field" style="justify-content: flex-start">
            <div style="display: flex; flex: 1">
              <input
                v-model="smCode"
                type="password"
                placeholder="请输入密码"
                class="input-field input-fieldPassword"
              />
            </div>
          </div>
        </div>

        <div v-if="isLock" class="login-container">
          <div class="custom-field">
            <div class="leftTip">图形验证</div>
            <div style="display: flex">
              <input
                v-model="pass"
                type="number"
                placeholder="请输入图形验证码"
                class="input-field"
              />
            </div>
            <div class="getCodeBtn" style="cursor: pointer">获取验证码</div>
          </div>
        </div>

        <div class="login" @click="goHome()" style="cursor: pointer">
          立即登录
        </div>

        <div class="body2">
          <div style="margin-left: 14px; display: flex;">
            <div
              class="custom-checkbox"
              :style="{
                backgroundImage: `url(${
                  isChecked ? checkedImg : uncheckedImg
                })`,
              }"
              @click="toggleCheck"
              style="cursor: pointer"
            ></div>
            <div class="read">我已阅读并同意</div>
            <div class="yinsi" v-if="loginType == 2">《注册协议》</div>
            <div class="read" style="margin-left: 0px" v-if="loginType == 2">
              和
            </div>
            <div class="yinsi">《隐私协议》</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { login } from "@/api";

export default {
  name: "LoginPage",
  data() {
    return {
      isWeChatEnv: false, // 【新增】用于存储是否在微信环境
      isLock: false,
      isChecked: false,
      // 关键修改：动态背景图用require引入assets资源
      checkedImg: require("@/assets/checked.png"),
      uncheckedImg: require("@/assets/unchecked.png"),
      loginType: 0,
      selectTag: 0,
      phone: "",
      customer: "",
      pass: "",
      smCode: "",
      checked: false,
    };
  },
  mounted() {
     // 【新增】判断是否在微信浏览器中
    const ua = navigator.userAgent.toLowerCase();
    this.isWeChatEnv = ua.indexOf('micromessenger') !== -1;
    const searchParams = new URLSearchParams(window.location.search);
    const token = searchParams.get("token");
    const isInMiniProgram = searchParams.get("isInMiniProgram");
    const currentMode = searchParams.get("mode") || "";
    const currentPlatform = searchParams.get("platform") || "";
    const path = searchParams.get("path") || "";
    if (token) {
      sessionStorage.setItem("token", token);
      sessionStorage.setItem("h5_uni_mode", currentMode);
      sessionStorage.setItem("h5_uni_platform", currentPlatform);
      sessionStorage.setItem("h5_isInMiniProgram", isInMiniProgram);
      console.log("token 已存入 sessionStorage:", token);
      if (path) {
        this.$router.replace({
          path: "/" + path,
        });
      } else {
        this.$router.replace({
          path: "/home",
        });
      }
    } else {
      //sit
      // const defaultToken =
      // 	'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJ1c2VySWQiOjMzNzc1OTM0ODM5MzYxOTQ1NiwidGVuYW50SWQiOjAsImV4cCI6MTc2OTY3NDkxMX0.vHj2LY-ES1teOeKHx39vPzLwx9rG5xuupFUHlP1jX6s';
      // const defaultToken =
      // 	'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJ1c2VySWQiOjM0NjQ4NTYwOTcxNDQzODE0NCwidGVuYW50SWQiOjAsImV4cCI6MTc2NjQ3NzQ1M30.Ct9VPptj59_-vAorpAwQM-d8J6cD8HH371OiQLmbgaI';
      // sessionStorage.setItem('token', defaultToken);
      // console.log('默认token已存入sessionStorage');
    }
  },
  methods: {
    handleSelect(tag) {
      console.log("当前 selectTag:", this.selectTag);
      this.selectTag = tag;
    },
    toggleCheck() {
      this.isChecked = !this.isChecked;
    },
    goRegister() {
      this.loginType = 2;
    },
    goLogin() {
      this.loginType = 0;
    },
    goRemenber() {
      this.loginType = 1;
    },
    getPassPlace() {
      return this.loginType == 1
        ? "由6~18位大小写字母、数字、特殊符号组成"
        : "请输入密码";
    },
    getBtnType(btn) {
      return btn == 0
        ? this.selectTag == 0
          ? "selected"
          : "unSelect"
        : this.selectTag == 1
        ? "selected"
        : "unSelect";
    },
    getloginTitle() {
      if (this.loginType == 0) return "欢迎登录";
      if (this.loginType == 1) return "忘记密码";
      return "用户注册";
    },
    async goHome() {
      if (!this.isChecked) {
        alert("请先阅读并同意《隐私协议》");
        return;
      }
      try {
        const data = {
          username: this.phone,
          password: this.smCode,
          tenantId: "0",
        };
        const res = await login(data);
        console.log("登录结果", res);
        if (res) {
          sessionStorage.setItem("token", res);
          this.$router.replace({
            path: "/home",
          });
        } else {
          alert(res);
        }
      } catch (err) {
        console.error("登录请求失败:", err);
        alert("登录失败，请稍后重试");
      }
    },
  },
};
</script>

<style scoped>
.contentAll {
  width: 100vw;
  height: 100vh;
  height: 100dvh;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  background: url("@/assets/loginBackground.png");
  /* background-repeat: no-repeat;  */
  /* background-size: cover;  */
  /* background-position: center center; */
  background-size: 100% auto;
  background-position: top center;
  background-repeat: no-repeat;
  background-color: #f8f9fe;
}
.loginAll {
  margin-top: 92.2633vw;
  /* display: flex;
  flex-direction: column;
  align-items: center; */
  padding: 0 10.133vw;
}
/* 自定义输入框容器样式 */
.custom-field {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 79.733vw;
  height: 12.8vw;
  border-radius: 53.866vw;
  background-color: #ffffff;
  /* 白色背景 */
  border: 0.266vw solid #ebebeb;
  /* 1px边框，颜色EBEBEB */
  /* 202px圆角转换为404rpx */
  padding: 0 4.8vw;
  box-sizing: border-box;
  margin-bottom: 3.733vw;
}

/* 输入框样式：占满容器，高度100% */
.input-field {
  width: 100%;
  height: 100%;
  font-size: 3.733vw;
  box-sizing: border-box;
  border: none;
  line-height: 5.866vw;
  height: 5.866vw;
}
.input-fieldPassword {
  letter-spacing: 2.133vw;
}

/* 输入框占位符样式 */
.input-field::placeholder {
  font-family: PingFang SC;
  font-size: 3.733vw;
  /* 14px转换为28rpx */
  font-weight: normal;
  line-height: 5.333vw;
  /* 20px转换为40rpx */
  letter-spacing: 0px;
  color: #a0a4aa;
}
/* 立即登录按钮样式调整 */
.login {
  height: 12.8vw;
  /* 48px转换为96rpx */
  border-radius: 53.866vw;
  /* 202px转换为404rpx */
  display: flex;
  align-items: center;
  justify-content: center;
  /* 核心修改：替换渐变背景色为指定的rgba值 */
  background: linear-gradient(
    270deg,
    rgba(28, 180, 241, 1) 0%,
    rgba(33, 124, 224, 1) 100%
  );
  width: 79.733vw;
  /* 与第二个输入框间隔18px(36rpx) */
  font-family: PingFang SC;
  font-size: 4.266vw;
  /* 16px转换为32rpx */
  font-weight: 500;
  line-height: 5.866vw;
  /* 22px转换为44rpx */
  text-align: center;
  letter-spacing: 0px;
  color: #ffffff;
  box-sizing: border-box;
}
/* 协议勾选模块样式调整 */
.body2 {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  height: 5.866vw;
  /* 22px转换为44rpx */
  margin-top: 4.266vw;
  /* 与登录按钮间隔18px(36rpx) */
}

/* 复选框样式 */
.custom-checkbox {
  width: 4.8vw;
  /* 18px转换为36rpx */
  height: 4.8vw;
  /* 18px转换为36rpx */
  background-size: 100% auto;
  background-position: top center;
  background-repeat: no-repeat;
}

/* 协议文字样式 */
.read {
  margin-left: 2.666vw;
  /* 5px转换为10rpx */
  height: 4.5333vw;
  /* 17px转换为34rpx */
  font-family: Source Han Sans;
  font-size: 3.2vw;
  /* 12px转换为24rpx */
  font-weight: normal;
  line-height: normal;
  letter-spacing: 0.06em;
  font-variation-settings: "opsz" auto;
  font-feature-settings: "kern" on;
  color: #7e849f;
}

.yinsi {
  font-family: Source Han Sans;
  font-size: 3.2vw;
  /* 12px转换为24rpx */
  font-weight: normal;
  line-height: normal;
  letter-spacing: 0.06em;
  font-variation-settings: "opsz" auto;
  font-feature-settings: "kern" on;
  color: #025cea;
}
</style>
